export default __webpack_public_path__ + "static/media/Img1.f4942ecd.jpg";